import { InputState } from './input.state';

export class RadioInputState extends InputState<boolean> {
	group: string;

	private static inputGroups: { [name: string]: RadioInputState[] } = {};

	constructor(label: string, group: string) {
		super(label);

		this.group = group;

		if (RadioInputState.inputGroups[group] == null) {
			RadioInputState.inputGroups[group] = [this];
		} else {
			RadioInputState.inputGroups[group].push(this);
		}
	}

	override setValue(val: boolean) {
		super.setValue(val);

		if (val) {
			const inputs = RadioInputState.inputGroups[this.group];
			if (inputs) {
				for (const input of inputs) {
					if (input !== this) {
						input.setValue(false);
					}
				}
			}
		}
	}
}
